var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEntity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 36.215v-6M45.624 41.58v0a3.548 3.548 0 01-3.174 5.135H25.548v0a3.548 3.548 0 01-3.174-5.136l8.452-16.904v0a3.548 3.548 0 016.346 0l8.452 16.904zM22.7 23.015v0a12.058 12.058 0 00-9.7-4.8h0a12 12 0 00-12 10.5M13 15.215a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5zM32.5 12.215a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5zM40.3 18.215v0a9 9 0 00-14.57-1.42",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNoEntity;